export class IdentityStatusService {
    #bus;
    #clock;
    #identity;
    #initialization;
    #status = { id: "device-identity", status: "initializing" };
    constructor(options) {
        this.#bus = options.bus;
        this.#clock = options.clock;
        this.#identity = options.identity;
        options.liveQueries.register({
            invalidateOn: ["query.invalidated"],
            key: (row) => row.id,
            name: "identity.status.v1",
            run: async () => [this.#status],
        });
    }
    start() {
        this.#initialization ??= this.#initialize();
        return this.#initialization;
    }
    async #initialize() {
        try {
            const identity = await this.#identity.generate();
            this.#status = {
                custodyMode: identity.custodyMode,
                id: "device-identity",
                status: "ready",
            };
        }
        catch {
            this.#status = { id: "device-identity", status: "unavailable" };
        }
        this.#bus.publish({
            occurredAt: this.#clock.now(),
            payload: { name: "identity.status.v1" },
            type: "query.invalidated",
        });
    }
}
//# sourceMappingURL=identity-status-service.js.map